import { Component, ViewChild } from '@angular/core';

import { ILogger } from 'projects/content-service-cms/src/app/logging';
import {
  AbstractFilterService,
  RRFilterBarComponent,
  RRFilterModule,
  buildInputElement,
} from 'projects/web-ui-component-library/src';
import { DateInputElementComponent } from 'projects/web-ui-component-library/src/lib/filter/components/filter-bar/filter-bar-element/date-input-element/date-input-element.component';
import { TextInputElementComponent } from 'projects/web-ui-component-library/src/lib/filter/components/filter-bar/filter-bar-element/text-input-element/text-input-element.component';
import {
  CollectionScreenStore,
  CollectionTag,
} from '../../../../collection-screen.state';
import { ITagService } from 'projects/content-service-cms/src/app/data/api';
import { CustomerStorageService } from 'projects/content-service-cms/src/app/customer/service/customer-storage.service';
import { SelectTagInputElementComponent } from 'projects/web-ui-component-library/src/lib/filter/components/filter-bar/filter-bar-element/select-tag-input-element/select-tag-input-element.component';

@Component({
  selector: 'app-collection-search-filter-bar',
  standalone: true,
  imports: [RRFilterModule],
  templateUrl: './collection-search-filter-bar.component.html',
  styleUrls: ['./collection-search-filter-bar.component.scss'],
})
export class CollectionSearchFilterBarComponent {
  clearFilterValues() {
    this.store.setFilters({});
  }
  @ViewChild('filterBar') filterBar: RRFilterBarComponent<CollectionFilters>;

  requestFilterService: RequestFilterService;

  constructor(
    private logger: ILogger,
    public store: CollectionScreenStore,
    private _tagService: ITagService,
    private _customerStorageService: CustomerStorageService,
  ) {
    this.requestFilterService = new RequestFilterService(store);

    this.store.filters$.subscribe((filters) => {
      this.requestFilterService.filterValues.next(filters);
    });
    this._tagService
      .getAllTagsByCustomerId(
        this._customerStorageService.getSelectedCustomer(),
      )
      .then((tags) => {
        store.setTags(
          tags.map((t) => ({ name: t.name, uuid: t.id, value: '' })),
        );
      });
    this.requestFilterService.filterValues.subscribe((filters) => {
      this.logger.debug('RequestListActionBar', 'filterValues:', filters);
      this.store.setFilters(filters);
    });
  }
}

export type CollectionFilters = {
  createdAt: { from: Date; to: Date };
  name: string;
  sku: string;
  tags: CollectionTag[];
};

class RequestFilterService extends AbstractFilterService<CollectionFilters> {
  constructor(store: CollectionScreenStore) {
    super({
      createdAt: {
        id: 'createdAt',
        label: 'Created',
        icon: 'calendar',
        ...buildInputElement(DateInputElementComponent),
      },
      sku: {
        id: 'sku',
        label: 'Reference',
        searchable: true,
        ...buildInputElement(TextInputElementComponent),
      },
      name: {
        id: 'name',
        label: 'Name',
        searchable: true,
        ...buildInputElement(TextInputElementComponent),
      },
      tags: {
        id: 'tags',
        icon: 'tags',
        label: 'Tags',
        searchable: true,
        ...buildInputElement<
          SelectTagInputElementComponent<CollectionFilters, 'tags'>
        >(SelectTagInputElementComponent, {
          formatItem: (item) => ({
            text: item.name,
          }),
          compareItem: (a, b) => a && b && a.uuid === b.uuid,
          selector: store.select((state) =>
            state.tags.map((t) => ({ name: t.name, uuid: t.uuid, value: '' })),
          ),
        }),
      },
    });
  }
}
